var _path, _path2, _path3, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoV2(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2546_24888)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2546_24888",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0H0.5V24H24.5V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.95312 22.125C4.95312 21.0894 5.79256 20.25 6.82812 20.25C7.86369 20.25 8.70312 21.0894 8.70312 22.125C8.70312 23.1606 7.86369 24 6.82812 24C5.79256 24 4.95312 23.1606 4.95312 22.125Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2546_24888)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2546_24888",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.90735e-06H24.5V24H0.5V1.90735e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2546_24888)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5445 12.2532L15.5689 9.91793C16.1645 9.57232 16.1645 8.70893 15.5689 8.36332L11.5445 6.02806C10.9484 5.68217 10.2031 6.11412 10.2031 6.80538V11.4759C10.2031 12.1671 10.9484 12.5991 11.5445 12.2532Z",
    stroke: "#86BB00",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5625 14.5313C23.5625 16.0845 22.3033 17.3438 20.75 17.3438H4.25C2.6967 17.3438 1.4375 16.0845 1.4375 14.5313V3.75C1.4375 2.1967 2.6967 0.937501 4.25 0.937501H20.75C22.3033 0.937501 23.5625 2.1967 23.5625 3.75V9.79688",
    stroke: "#86BB00",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82812 22.0781H1.4375",
    stroke: "#86BB00",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5625 22.0781H11.5156",
    stroke: "#86BB00",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95312 22.125C4.95312 21.0894 5.79256 20.25 6.82812 20.25C7.86369 20.25 8.70312 21.0894 8.70312 22.125C8.70312 23.1606 7.86369 24 6.82812 24C5.79256 24 4.95312 23.1606 4.95312 22.125Z",
    fill: "#86BB00"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2546_24888"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoV2);
export default __webpack_public_path__ + "static/media/VideoV2.e9295301f0444223326e6bfa670f408d.svg";
export { ForwardRef as ReactComponent };